import React from 'react'
import { Link } from 'react-scroll';
import './AboutUs.css'



function AboutUs({topline, headline, description, btnLabel, aboutImg }) {


  return (
    <>
      <div className='about-section' id='AboutUs'>
        <div className="container">
            <div className="about-content">
                <div className="about-text">
                    <div className="tagline">
                        <span>{topline}</span>
                    </div>
                    <h2>{headline}</h2>
                    <p className='text'>{description}.</p>
                   <Link
                        activeClass="active" 
                        to="Contact" 
                        spy={true} 
                        smooth={true} 
                        duration={500}
                        >
                        <button className='btn'   
                        >{btnLabel}</button>
                    </Link>
                </div>
                
                <div className="about-image">
                  <img src={aboutImg} alt="" />
                </div>
            </div>
        </div>
        
      </div>
    </>
  )
}

export default AboutUs
